import React from 'react';
import './ChevronProcessDiagram.scss';
import { ChevronDiagramStage } from './models/ChevronDiagramStage';
import { ChevronDiagramTimelineEvent } from './ChevronDiagramTimelineEvent';
import { ChevronDiagramEvent } from './models/ChevronDiagramEvent';
import { TimelineParty } from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';

interface ChevronDiagramColumnProps {
    chevronDiagramStage: ChevronDiagramStage;
    onActionClick(item: ChevronDiagramEvent): void;
    isEventActionVisible: (eventId: string) => boolean;
    party: TimelineParty;
    isTempoPreview?: boolean;
    engagementId: number;
    isBuyerView: boolean;
    hideExecuteButton: boolean;
}

export const ChevronDiagramColumn = (props: ChevronDiagramColumnProps) => {
    return (
        <div
            className="chevron-diagram-column"
            style={
                {
                    '--phase-color': props.chevronDiagramStage.backgroundColor,
                } as React.CSSProperties
            }>
            <div className="phase">
                <div className="phase-name">
                    {props.chevronDiagramStage.name}
                </div>
            </div>
            <div
                className={`data-column ${
                    props.isTempoPreview ? 'previewing-tempo' : ''
                }`}>
                {props.chevronDiagramStage.events.map((event) => (
                    <ChevronDiagramTimelineEvent
                        chevronDiagramEvent={event}
                        onActionClick={props.onActionClick}
                        isEventActionVisible={props.isEventActionVisible}
                        party={props.party}
                        engagementId={props.engagementId}
                        isBuyerView={props.isBuyerView}
                        hideExecuteButton={props.hideExecuteButton}
                    />
                ))}
            </div>
        </div>
    );
};
